//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { focus } from '~/helpers/directives';
import SfLink from '../SfLink.vue';

export default {
  name: 'SfButton',
  directives: {
    focus,
  },
  inject: {
    components: {
      default: { SfLink },
    },
  },
  props: {
    type: {
      type: String,
      default: 'button',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      validator: (value) => ['button', 'submit', 'reset'].includes(value),
    },
    link: {
      type: [String, Object],
      default: null,
    },
    variant: {
      type: String,
      default: 'primary',
      // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
      validator: (value) => ['primary', 'secondary', 'outlined', 'outlined-white', 'outlined-black', 'text', 'pure'].includes(value),
    },
    ariaLabel: {
      type: String,
      default: 'button',
    },
  },
};
